import React from 'react'

import Filter from '@/ui/DataTable/Filter'
import TextInput from '@/ui/Data/TextInput'

const SearchFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn placeholder="Search" />
  </Filter>
)

export default SearchFilter



// WEBPACK FOOTER //
// ./view/Dashboard/Search.js